import { render, staticRenderFns } from "./ViewTechnical.vue?vue&type=template&id=6f716b24&"
import script from "./ViewTechnical.vue?vue&type=script&lang=js&"
export * from "./ViewTechnical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports